import { AxiosResponse } from 'axios';

export const res = (r: AxiosResponse): any => r.data;
